
import { defineComponent, ref } from 'vue';
import { message } from 'ant-design-vue';

export default defineComponent({
  name: 'JSONEditModel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    json: {
      type: Object,
      default: () => {},
    },
    onlyread: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props, { emit }) {
    const loading = ref(false);
    const json_obj: any = ref({});
    const container = ref<any>();

    json_obj.value = props.json;

    const handleCancel = () => {
      emit('cancel');
    };
    const handleOK = () => {
      emit('ok', json_obj.value);
    };

    return {
      // fullscreen
      message,
      // edit
      loading,
      json_obj,
      container,
      handleCancel,
      handleOK,
    };
  },
});
